<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="rounded-xl">
    <div class="flex justify-between items-center mb-4 sm:mb-6">
        <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">Investor Management</h2>
        <div class="flex gap-2">
            <button (click)="openArchivedUsersDialog()"
                class="px-3 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors">
                <i-lucide name="archive" class="h-4 w-4 mr-1"></i-lucide>
                Archived Users
            </button>
        </div>
    </div>

    <!-- Search and Filters for Main Users Table -->
    <div class="mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex flex-col md:flex-row gap-3 items-center">
            <div class="flex-1">
                <div class="relative">
                    <input type="text"
                           pInputText
                           placeholder="Search by name, email, or phone..."
                           [(ngModel)]="searchTerm"
                           (input)="onSearchInput($event)"
                           class="w-full pl-10 pr-10">
                    <button *ngIf="searchTerm"
                            (click)="clearSearch()"
                            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                        <i-lucide name="x" class="h-4 w-4"></i-lucide>
                    </button>
                </div>
            </div>
        </div>
    </div>

 <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="text-sm sm:text-base">Loading investors...</p>
    </div>
      <div *ngIf="!isLoading" class="transactions-table-container">
    <p-table [value]="users" [paginator]="false" [responsive]="true" class="p-datatable-sm w-full rounded-lg overflow-hidden" [style]="{ 'max-height': '700px' }">
        <ng-template pTemplate="header">
            <tr class="bg-gray-50">
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden sm:table-cell">Email</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden md:table-cell">Phone</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden lg:table-cell">Investment Goals</th>
                 <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Verified</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden md:table-cell">Last Login</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden lg:table-cell">Created</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr class="hover:bg-gray-50 transition-colors">
                <td class="px-2 sm:px-4 py-2 sm:py-3">
                    <div>
                        <span class="font-medium text-gray-900 text-xs sm:text-sm cursor-pointer underline" pTooltip="View" (click)="openUserDetailsDialog(user._id)">{{ user.fullName }}</span>
                        <div class="sm:hidden text-xs text-gray-500 mt-1">{{ user.email }}</div>
                        <div class="md:hidden text-xs text-gray-500 mt-1">{{ user.phone }}</div>
                    </div>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 hidden sm:table-cell">
                    <span class="text-gray-700 text-xs sm:text-sm">{{ user.email }}</span>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 hidden md:table-cell">
                    <span class="text-gray-700 text-xs sm:text-sm">{{ user.phone }}</span>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 hidden lg:table-cell">
                    <span class="text-blue-700 font-medium capitalize text-xs sm:text-sm">{{ user.investmentGoals.replace('-', ' ') }}</span>
                </td>
                 <td class="px-2 sm:px-4 py-2 sm:py-3">
                    <div>
                        <span [ngClass]="user.emailVerified ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'" class="px-2 py-1 rounded-full text-xs font-semibold">
                            {{ user.emailVerified ? 'Yes' : 'No' }}
                        </span>
                    </div>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3">
                    <div>
                        <span [ngClass]="user.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'" class="px-2 py-1 rounded-full text-xs font-semibold">
                            {{ user.isActive ? 'Active' : 'Inactive' }}
                        </span>
                        <div class="lg:hidden text-xs text-gray-500 mt-1 capitalize">{{ user.investmentGoals.replace('-', ' ') }}</div>
                    </div>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 hidden md:table-cell">
                    <span class="text-gray-600 text-xs">{{ user.lastLogin ? (user.lastLogin | date:'medium') : 'Never' }}</span>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 hidden lg:table-cell">
                    <span class="text-gray-600 text-xs">{{ user.createdAt | date:'mediumDate' }}</span>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3">
                    <div class="flex gap-2">
                        <button (click)="confirmResetPassword(user)"
                            [disabled]="resettingPasswordUserId===user._id"
                            class="p-1.5 sm:p-2 rounded-full bg-white border border-amber-300 hover:bg-amber-50 text-amber-600 hover:text-amber-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                            pTooltip="Reset password and send temporary password">
                            <ng-container *ngIf="resettingPasswordUserId===user._id; else resetIcon">
                                <i-lucide name="loader-circle" class="h-4 w-4 animate-spin"></i-lucide>
                            </ng-container>
                            <ng-template #resetIcon>
                                <i-lucide name="key-round" class="h-4 w-4"></i-lucide>
                            </ng-template>
                        </button>
                        <button (click)="confirmDelete(user)"
                            [disabled]="deletingUserId===user._id"
                            class="p-1.5 sm:p-2 rounded-full bg-white border border-red-300 hover:bg-red-50 text-red-600 hover:text-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                            pTooltip="Delete user (cannot be undone)">
                            <ng-container *ngIf="deletingUserId===user._id; else delIcon">
                                <i-lucide name="loader-circle" class="h-4 w-4 animate-spin"></i-lucide>
                            </ng-container>
                            <ng-template #delIcon>
                                <i-lucide name="trash-2" class="h-4 w-4"></i-lucide>
                            </ng-template>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" style="text-align: center;" class="text-center py-8 text-gray-400">No investors found.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-paginator [rows]="pagination.itemsPerPage" [totalRecords]="pagination.totalItems" [first]="(pagination.currentPage - 1) * pagination.itemsPerPage" [rowsPerPageOptions]="[5, 10, 20, 50]" (onPageChange)="onPageChange($event)" class="mt-4 sm:mt-6"></p-paginator>
</div>
    <div *ngIf="error" class="mt-3 sm:mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
        <p class="text-red-600 text-xs sm:text-sm">{{ error }}</p>
    </div>
</div>

<!-- Reset Password Confirmation Modal -->
<p-dialog 
    [(visible)]="showResetPasswordModal" 
    [modal]="true" 
    [style]="{width: '90vw', 'max-width': '500px'}" 
    [draggable]="false" 
    [resizable]="false"
    [closable]="!resettingPasswordUserId"
    [closeOnEscape]="!resettingPasswordUserId"
    [showHeader]="false">
    
    <div class="p-6">
        <!-- Header with Icon -->
        <div class="flex items-center gap-3 mb-6">
            <div class="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                <i-lucide name="key-round" class="h-6 w-6 text-amber-600"></i-lucide>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">Reset User Password</h3>
        </div>

        <!-- Content -->
        <div class="mb-6">
            <p class="text-gray-700 text-sm sm:text-base mb-3">
                Are you sure you want to reset the password for:
            </p>
            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex items-center gap-2 mb-2">
                    <i-lucide name="user" class="h-4 w-4 text-gray-500"></i-lucide>
                    <span class="font-semibold text-gray-900">{{ selectedUserForReset?.fullName }}</span>
                </div>
                <div class="flex items-center gap-2">
                    <i-lucide name="mail" class="h-4 w-4 text-gray-500"></i-lucide>
                    <span class="text-sm text-gray-600">{{ selectedUserForReset?.email }}</span>
                </div>
            </div>
            <p class="text-xs sm:text-sm text-gray-500 mt-3 flex items-start gap-2">
                <i-lucide name="info" class="h-4 w-4 flex-shrink-0 mt-0.5"></i-lucide>
                <span>A temporary password will be sent to the user's email address.</span>
            </p>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-3">
            <button 
                (click)="cancelResetPassword()" 
                [disabled]="resettingPasswordUserId"
                class="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                No
            </button>
            <button 
                (click)="executeResetPassword()" 
                [disabled]="resettingPasswordUserId"
                class="px-5 py-2.5 text-sm font-medium text-white bg-amber-600 border border-transparent rounded-lg hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 min-w-[100px]">
                <i-lucide *ngIf="resettingPasswordUserId" name="loader-circle" class="h-4 w-4 animate-spin"></i-lucide>
                <span>{{ resettingPasswordUserId ? 'Resetting...' : 'Yes' }}</span>
            </button>
        </div>
    </div>
</p-dialog>

<!-- User Details Dialog -->
<p-dialog header="User Details" [(visible)]="showUserDetailsDialog" [modal]="true" [style]="{width: '70vw'}" [draggable]="false" [resizable]="false" [contentStyle]="{'max-height': '80vh', 'overflow': 'auto'}">
    <app-view-user-details [userId]="selectedUserId"></app-view-user-details>
    <ng-template pTemplate="footer">
        <button pButton icon="pi pi-times" (click)="showUserDetailsDialog=false" label="Close" class="p-button-text"></button>
    </ng-template>
</p-dialog>

<!-- Archived Users Modal -->
<p-dialog
    header="Archived Unverified Users"
    [(visible)]="showArchivedUsersModal"
    [modal]="true"
    [style]="{width: '95vw', 'max-width': '1200px'}"
    [draggable]="false"
    [resizable]="false"
    [contentStyle]="{'max-height': '80vh', 'overflow': 'auto'}">

    <!-- Search and Filters -->
    <div class="mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex flex-col md:flex-row gap-3 items-center">
            <div class="flex-1">
                <div class="relative">
                    <input type="text"
                           pInputText
                           placeholder="Search by name, email, or phone..."
                           [(ngModel)]="archivedUsersSearchTerm"
                           (input)="onArchivedUsersSearchInput($event)"
                           class="w-full pl-10 pr-10">
                    <i-lucide name="search" class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"></i-lucide>
                    <button *ngIf="archivedUsersSearchTerm"
                            (click)="clearArchivedUsersSearch()"
                            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                        <i-lucide name="x" class="h-4 w-4"></i-lucide>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="archivedUsersLoading" class="flex items-center justify-center py-8">
        <div class="loading-spinner mr-3"></div>
        <p class="text-gray-600">Loading archived users...</p>
    </div>

    <!-- Archived Users Table -->
    <div *ngIf="!archivedUsersLoading">
        <p-table
            [value]="archivedUsers"
            [paginator]="false"
            [responsive]="true"
            class="p-datatable-sm"
            [style]="{ 'max-height': '500px' }">

            <ng-template pTemplate="header">
                <tr class="bg-gray-50">
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden sm:table-cell">Email</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden md:table-cell">Phone</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden lg:table-cell">Investment Goals</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Registration Date</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider hidden md:table-cell">Archived Date</th>
                    <th class="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Reason</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-archivedUser>
                <tr class="hover:bg-gray-50 transition-colors">
                    <td class="px-3 py-3">
                        <div class="font-medium text-gray-900 text-sm">
                            {{ archivedUser.firstName }} {{ archivedUser.lastName }}
                        </div>
                        <div class="sm:hidden text-xs text-gray-500 mt-1">{{ archivedUser.email }}</div>
                        <div class="md:hidden text-xs text-gray-500 mt-1">{{ archivedUser.phone }}</div>
                    </td>
                    <td class="px-3 py-3 hidden sm:table-cell">
                        <span class="text-gray-700 text-sm">{{ archivedUser.email }}</span>
                    </td>
                    <td class="px-3 py-3 hidden md:table-cell">
                        <span class="text-gray-700 text-sm">{{ archivedUser.phone }}</span>
                    </td>
                    <td class="px-3 py-3 hidden lg:table-cell">
                        <span class="text-blue-700 font-medium capitalize text-sm">{{ archivedUser.investmentGoals?.replace('-', ' ') }}</span>
                    </td>
                    <td class="px-3 py-3">
                        <span class="text-gray-600 text-sm">{{ archivedUser.registrationDate | date:'mediumDate' }}</span>
                        <div class="lg:hidden text-xs text-gray-500 mt-1 capitalize">{{ archivedUser.investmentGoals?.replace('-', ' ') }}</div>
                    </td>
                    <td class="px-3 py-3 hidden md:table-cell">
                        <span class="text-gray-600 text-sm">{{ archivedUser.archivedDate | date:'mediumDate' }}</span>
                    </td>
                    <td class="px-3 py-3">
                        <span class="inline-flex items-center px-2.5 py-0.5text-xs font-medium  text-red-800">
                            {{ archivedUser.reason }}
                        </span>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7" class="text-center py-8 text-gray-500">
                        No archived users found
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <!-- Pagination for Archived Users -->
        <p-paginator
            [rows]="archivedUsersPagination.itemsPerPage"
            [totalRecords]="archivedUsersPagination.totalItems"
            [first]="(archivedUsersPagination.currentPage - 1) * archivedUsersPagination.itemsPerPage"
            [rowsPerPageOptions]="[5, 10, 20, 50]"
            (onPageChange)="onArchivedUsersPageChange($event)"
            class="mt-4">
        </p-paginator>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button
                icon="pi pi-times"
                label="Close"
                (onClick)="closeArchivedUsersModal()"
                styleClass="p-button-text">
            </p-button>
        </div>
    </ng-template>
</p-dialog>